import React from 'react';
import Button from '../atoms/Button';

const ReportUnenrichedButton = ({ unenriched, ...restProps }) => {
    return (
        <Button
            text="STATIC.BUTTONS.UNENRICHED"
            type="secondary"
            forceActive={unenriched}
            style={{ marginRight: '10px' }}
            {...restProps}
        />
    );
};

export default ReportUnenrichedButton;
